<template>
  <div class="w-full">
    <Modal v-model="props.isModal" containerClass="w-4/5 border-2 border-primary p-2">
      <template #container>
        <Cropper @cancel="onCancel" :image="image" @confirm="onConfirm" />
      </template>
    </Modal>
  </div>
</template>
<script setup>
import { defineEmits } from 'vue'
import Modal from '@/components/Ui/Modal/index.vue'
import Cropper from '@/components/Cropper/index.vue'

const emits = defineEmits(['onClose', 'confirm'])
const props = defineProps({
  isModal: {
    type: Boolean,
    default: () => false
  },
  label: {
    type: String,
    default: 'confirmationMsgFav'
  },
  image: {
    type: Object,
    required: true
  }
})

const onCancel = () => {
  emits('onClose')
}
const onConfirm = (newImage) => {
  emits('confirm', newImage)
}
</script>
